var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"icon-custom",class:[_vm.icon]}),(_vm.$store.state.show_menu_text)?_c('span',[_c('span',[_vm._v("  ")]),_c('span',{staticClass:"nav-label"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }